// extracted by mini-css-extract-plugin
export default {"container":"iLB2xji_","illustration":"DJwy0OnU"};